import { type ColumnDef } from '@tanstack/react-table';

import { DateCell } from '@/components/composed/DateCell';
import { IdCell } from '@/components/composed/IdCell';
import { MaskedCell } from '@/components/composed/MaskedCell';
import { StatusBadge } from '@/components/composed/StatusBadge';
import type { TableFeatures } from '@/components/composed/DataTable/table-features';
import type { GeneralAgent } from '@/lib/api/domains/general-agents';

export const generalAgentColumns: Array<
  ColumnDef<TableFeatures, GeneralAgent>
> = [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: (info) => (
      <span className="font-medium">{info.getValue<string>()}</span>
    ),
  },
  {
    accessorKey: 'publicId',
    header: 'Public ID',
    cell: (info) => {
      const value = info.getValue<string | undefined>();
      return value ? <IdCell value={value} /> : null;
    },
  },
  {
    accessorKey: 'npn',
    header: 'NPN',
    cell: (info) => info.getValue<string | undefined>() ?? null,
  },
  {
    accessorKey: 'taxId',
    header: 'TIN',
    cell: (info) => {
      // Masked by default — full TIN is PII and never shown here (product
      // non-negotiables). A permission-gated reveal would be a feature decision.
      const value = info.getValue<string | undefined>();
      return value ? <MaskedCell value={value} /> : null;
    },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: (info) => {
      const status = info.getValue<GeneralAgent['status']>();
      return (
        <StatusBadge
          label={status === 'active' ? 'Active' : 'Inactive'}
          tone={status === 'active' ? 'success' : 'neutral'}
        />
      );
    },
  },
  {
    accessorKey: 'createdAt',
    header: 'Created',
    cell: (info) => <DateCell value={info.getValue<string>()} />,
  },
];
